import { motion } from 'framer-motion';

const useCases = [
  {
    title: "Boost Google Reviews",
    description: "Use smart WhatsApp automation to gently ask happy customers for 5-star Google reviews.",
    image: "/images/usecases/reviews.png", // <-- Replace this with an appropriate image
  },
  {
    title: "Verified Green Tick",
    description: "Establish instant trust with customers by showcasing your official verified green tick.",
    image: "/images/usecases/greentick.png", // <-- Replace this with an appropriate image
  },
  {
    title: "Build Online Reputation",
    description: "Turn satisfied customers into brand advocates and strengthen your credibility.",
    image: "/images/usecases/reputation.png", // <-- Replace this with an appropriate image
  },
  {
    title: "Review Campaign Automation",
    description: "Set up automated review campaigns triggered after purchases or service delivery.",
    image: "/images/usecases/automation.png", // <-- Replace this with an appropriate image
  },
];

const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const UseCases = () => {
  return (
    <motion.section
      id="use-cases"
      className="bg-white py-16 px-4 md:px-20"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      variants={containerVariants}
    >
      <motion.h2
        className="text-3xl font-bold text-center mb-12 text-gray-800"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        Turn Happy Customers Into Promoters
      </motion.h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        {useCases.map((caseItem, index) => (
          <motion.div
            key={index}
            variants={cardVariants}
            whileHover={{ scale: 1.05 }}
            className="bg-gray-50 p-6 rounded-xl shadow-sm hover:shadow-md transition"
          >
            <img
              src={caseItem.image}
              alt={caseItem.title}
              className="h-20 mx-auto mb-6"
            />
            <h3 className="text-xl font-semibold text-gray-700 mb-2 text-center">
              {caseItem.title}
            </h3>
            <p className="text-gray-600 text-center">{caseItem.description}</p>
          </motion.div>
        ))}
      </div>
    </motion.section>
  );
};

export default UseCases;
